module.exports = __webpack_public_path__ + "static/media/painting1.d6c0cbe7.jpg";